

import { CreatorWithPercentage } from "../model/PackForm";

interface ValidateFormProps {
  name: string;
  description: string;
  creator: string;
  coverPreview: string | null;
  presets: any[];
  setError: (field: string, message: string) => boolean;
  published?: boolean;
  creators?: Partial<CreatorWithPercentage>[];
}

export const usePackValidation = () => {
  const validateForm = ({
    name,
    description,
    creator,
    coverPreview,
    setError,
    creators = []
  }: ValidateFormProps) => {
    let isValid = true;

    // Validação básica do formulário
    if (!name.trim()) {
      isValid = setError('name', 'O nome é obrigatório');
    }

    if (!description.trim()) {
      isValid = setError('description', 'A descrição é obrigatória');
    }

    if (!creator) {
      isValid = setError('creator', 'O criador é obrigatório');
    }

    if (!coverPreview) {
      isValid = setError('cover', 'A capa é obrigatória');
    }

    // Validação dos criadores
    if (creators.length > 0) {
      const totalPercentage = creators.reduce((sum, creator) => sum + (creator.percentage || 0), 0);
      if (totalPercentage !== 100) {
        isValid = setError('creators', 'A soma das porcentagens deve ser 100%');
      }

      // Verifica se há porcentagens inválidas (<= 0)
      const hasInvalidPercentage = creators.some(creator => !creator.percentage || creator.percentage <= 0); if (hasInvalidPercentage) {
        isValid = setError('creators', 'As porcentagens devem ser maiores que 0%');
      }
    }

    // Removed presets validation to allow saving without presets

    return isValid;
  };

  return { validateForm };
};
